import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import Dissatisfied from 'components/icons/Dissatisfied'
import { useDispatch, useSelector } from 'react-redux'
import { getSingleRoleDetails } from 'modules/JobPreview/action'
import { getRuleEngine } from 'modules/RuleEngine/action'
import ruleEngineSelectors from 'modules/RuleEngine/selectors'
import { getPlacedStatus } from 'modules/RuleEngine/Components/RuleEngineCommonFunction'
import { Container, Title, ReasonList, ReasonItem, Circle, ReasonText } from './style'




const RestrictionsPanel = ({record,roleId}) => {
const [messages, setMessages] = useState([])
const [messagePopup, setMessagePopup] = useState([])
const [viewRoleDetails, setViewRoleDetails] = useState({})
const [loading, setLoading] = useState(false)

const dispatch = useDispatch()
const ruleEngineData = useSelector(ruleEngineSelectors.getRuleEngine)

useEffect(() => {
 setLoading(true)
 fetchSingleRoleDetails()
 // Fetch rule engine data if not already available
 if (!ruleEngineData) {
   dispatch(getRuleEngine())
 }
}, [roleId])

useEffect(() => {
  console.log('Rule Engine Data:', ruleEngineData)
}, [ruleEngineData])
const fetchSingleRoleDetails = async () => {
 let result = await dispatch(getSingleRoleDetails(roleId,record?.id))
 setViewRoleDetails(result)
 setLoading(false)
}
  useEffect(() => {
    const checks = []
    const popupChecks = []

    // Extract dynamic values from rule engine data
    const getDynamicValues = () => {
      const defaults = {
        rolesApplyingThreshold: 1,
        maxRolesAllowed: 1,
        absentStudentsLimit: 1,
        intentToOfferLimit: 1,
        minimumThreshold: null
      }

      if (!ruleEngineData) return defaults

      try {
        const formatMinimumThreshold = (lpaValue) => {
          if (!lpaValue || isNaN(lpaValue)) return null
          const rupees = Number(lpaValue) * 100000
          return rupees.toLocaleString('en-IN')
        }

        return {
          rolesApplyingThreshold: ruleEngineData?.rolesApplyingThreshold ?? defaults.rolesApplyingThreshold,
          maxRolesAllowed: ruleEngineData?.maxRolesAllowed ?? defaults.maxRolesAllowed,
          absentStudentsLimit: ruleEngineData?.absentStudents ?? defaults.absentStudentsLimit,
          intentToOfferLimit: ruleEngineData?.applicationStatusThresholds?.intentToOffer ?? defaults.intentToOfferLimit,
          minimumThreshold: formatMinimumThreshold(ruleEngineData?.applicationStatusThresholds?.minimumThreshold)
        }
      } catch (error) {
        console.error('Error extracting rule engine values:', error)
        return defaults
      }
    }

    const dynamicValues = getDynamicValues()
    console.log('Dynamic Values for Restrictions:', dynamicValues)

    const addMessage = (id, rawMessage) => {
      popupChecks.push(rawMessage)
      checks.push({ id, message: rawMessage })
    }

    if (
      viewRoleDetails?.restrictedReason?.absentLimit &&
      viewRoleDetails.restrictedReason.absentLimit.limit <=
        viewRoleDetails.restrictedReason.absentLimit.used
    ) {
      addMessage(
        1,
        `Student has missed ${dynamicValues.absentStudentsLimit} evaluation processes`
      )
    }

    if (
      viewRoleDetails?.restrictedReason?.applyLimit &&
      !viewRoleDetails.restrictedReason.applyLimit.isEligible &&
      viewRoleDetails.restrictedReason.applyLimit.limit <=
        viewRoleDetails.restrictedReason.applyLimit.used
    ) {
      const maxAllowed =
        Number.isFinite(Number(dynamicValues.maxRolesAllowed)) &&
        Object.keys(ruleEngineData || {}).length > 0
          ? Number(dynamicValues.maxRolesAllowed)
          : Number(viewRoleDetails?.restrictedReason?.applyLimit?.limit || 1)

      addMessage(
        2,
        `Student has already used the maximum allowed number of applications (${maxAllowed})`
      )
    }

    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.limit <=
        viewRoleDetails.restrictedReason.offerLimit.used
    ) {
      const placementType = ruleEngineData?.applicationStatusThresholds?.placementType || 'INTENT_TO_OFFER'
      const placementTypeText = getPlacedStatus(placementType)
      addMessage(
        3,
        `Student has "${placementTypeText}" from ${viewRoleDetails.restrictedReason.offerLimit.used} ${
          viewRoleDetails.restrictedReason.offerLimit.limit > 1 ? 'roles' : 'role'
        }`
      )
    }
    if (
      viewRoleDetails?.restrictedReason?.offerLimit?.isMinimumThresholdReached &&
      dynamicValues.minimumThreshold
    ) {
      addMessage(8, `Student has exceeded the minimum placement threshold (₹${Number(viewRoleDetails?.restrictedReason?.offerLimit?.minimumThreshold || dynamicValues.minimumThreshold).toLocaleString('en-IN')})`)
    }
    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.exceptionalFor.includes(
        'multiplesAmount'
      )
    ) {
      addMessage(
        4,
        `Role compensation is less than ${viewRoleDetails.restrictedReason.offerLimit.multiples}x of the student's current offer CTC`
      )
    }

    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.exceptionalFor.includes(
        'absoluteAmount'
      )
    ) {
      addMessage(
        5,
        `Role package is below ₹${viewRoleDetails.restrictedReason.offerLimit.absoluteAmount.toLocaleString()}`
      )
    }

    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.exceptionalFor.includes(
        'compensationRange'
      )
    ) {
      const currentPackageName = viewRoleDetails.restrictedReason.offerLimit
        .currentPackage
        ? viewRoleDetails.restrictedReason.offerLimit.currentPackage.name
        : 'current package'
      const placementType = ruleEngineData?.applicationStatusThresholds?.placementType || 'INTENT_TO_OFFER'
      const placementTypeText = getPlacedStatus(placementType)
      addMessage(
        6,
        `This role belongs to a lower compensation tier than the student's highest existing ${placementTypeText}`
      )
    }
    if (
      viewRoleDetails?.restrictedReason?.initialMissLimit &&
      viewRoleDetails.restrictedReason.initialMissLimit.limit <=
        viewRoleDetails.restrictedReason.initialMissLimit.used
    ) {
      addMessage(
        7,
        `Student has missed the first ${dynamicValues.rolesApplyingThreshold} eligible ${
          dynamicValues.rolesApplyingThreshold > 1 ? 'roles' : 'role'
        }, despite being eligible`
      )
    }
    setMessages(checks)
    setMessagePopup(popupChecks)
  }, [viewRoleDetails?.restrictedReason, ruleEngineData])
  
  return (
    <Container>
      <Title>Reasons for Restriction</Title>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
          <Spin size="small" />
        </div>
      ) : (
        <ReasonList>
          {messagePopup?.map((reason, index) => (
            <ReasonItem key={index}>
              <Dissatisfied style={{ 
                flexShrink: 0, 
                marginTop: '2px',
                width: '16px',
                height: '16px',
                color: '#ff4d4f'
              }}/>
              <ReasonText dangerouslySetInnerHTML={{ __html: reason }}></ReasonText>
            </ReasonItem>
          ))}
        </ReasonList>
      )}
    </Container>
  )
}

export default RestrictionsPanel